/**
 * Resolve vehicle image paths for public pages and sharing.
 * Handles relative uploads paths and legacy malformed URLs from older API responses.
 *
 * Upload files live under /api/uploads/. Demo seed SVGs live under /seed/ at the site root
 * (CRA public/ → deploy dist/), so they must NOT be prefixed with /api.
 */
export function resolvePublicFileUrl(
  path: string | null | undefined,
  apiBase = '/api'
): string | null {
  if (!path) return null;

  let url = path.trim();
  if (!url) return null;

  // Fix legacy bug: https://host/apiuploads/... → https://host/api/uploads/...
  if (/^https?:\/\//i.test(url)) {
    return url.replace(/\/apiuploads\//i, '/api/uploads/');
  }

  const base = apiBase.endsWith('/') ? apiBase.slice(0, -1) : apiBase;
  const clean = url.replace(/^\/+/, '');

  // Site-root static assets (demo seed placeholders, brand, etc.)
  if (
    clean.startsWith('seed/') ||
    clean.startsWith('brand/') ||
    clean.startsWith('static/')
  ) {
    return `/${clean}`;
  }

  if (clean.startsWith('api/')) {
    return `${base}/${clean.slice(4)}`;
  }

  return `${base}/${clean}`;
}

export function isGalleryImageType(imageType?: string | null): boolean {
  return !imageType || imageType === 'hero' || imageType === 'gallery';
}
